import styled from 'styled-components';
import { token } from '@bynder/design-system';

export const StyledFlex = styled.div`
    display: flex;
    gap: ${token.spacing6};
    flex-wrap: wrap;
    align-content: flex-start;
`;
